export const prepareSingleValueChart = (chart) => {
    if (!chart) {
        return { timestamps: [], values: [] };
    }
    return {
        timestamps: chart.timestamps,
        values: chart.values.map(({ value }) => value),
    };
};
